import { useCallback } from 'react';

import { type AllInstructionsData } from 'src/data/generation';
import { type EditorType } from 'src/data/project';

import { useMainActions } from '../../store';

export const useHandlers = () => {
  const mainActions = useMainActions();

  const handlePromptChange = useCallback(
    (newValue: string, newData: AllInstructionsData) => {
      mainActions.updatePrompt(newValue, newData);
    },
    [mainActions]
  );

  const handleEditorChange = useCallback(
    (newValue: EditorType) => {
      mainActions.updateEditorType(newValue);
    },
    [mainActions]
  );

  return {
    handlePromptChange,
    handleEditorChange,
  };
};
